export enum EAircraftEventStatus {
  OnDuty = 'OnDuty',
  OffDuty = 'OffDuty',
  NotAvailable = 'NotAvailable',
  OnTrip = 'OnTrip',
  OnMaintenance = 'OnMaintenance',
  OnCrewDuty = 'OnCrewDuty',
}
